module.exports = __webpack_public_path__ + "img/1.835fb565.png";